import { useEffect, useState } from 'react';
import { FaInfoCircle, FaSync } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { BookingAction, SearchStatus } from '../../../../../../constants';
import { getTripConfirmationRequest } from '../../../../../../store/slices/trip';
import RefreshButton from '../../../../../Button/RefreshButton';

const FlightTicketingStatus = ({ trip }) => {
  const dispatch = useDispatch();
  const { travelAgency } = useSelector((store) => store.user);
  const { status: tripConfirmationStatus } = useSelector((store) => store.trip);
  const [isLoading, setIsLoading] = useState(false);
  const descriptionOnHover = isLoading ? 'fetching...' : 'Click to refresh ticketing status';

  useEffect(() => {
    if (isLoading && tripConfirmationStatus !== SearchStatus.SEARCHING) setIsLoading(false);
  }, [tripConfirmationStatus, isLoading]);

  const handleGetConfirmation = () => {
    if (tripConfirmationStatus === SearchStatus.SEARCHING) return;
    setIsLoading(true);
    dispatch(getTripConfirmationRequest({ tripId: trip.tripId }));
  };

  let statusText;
  if (trip.isFlightTicketed === true) statusText = 'Ticketed';
  else if (trip.isFlightTicketed === false) statusText = 'Not Ticketed';
  else if (trip.tripStatus === BookingAction.CANCELLED) statusText = 'Not Ticketed';
  else if (trip.tripStatus !== BookingAction.BOOK) statusText = 'To be determined';

  if (statusText) return <span>{statusText}</span>;

  const isCurrentAgencyTrip = trip.travelAgencyId === travelAgency?.id;
  if (!isCurrentAgencyTrip) {
    return (
      <span
        title={`This trip belongs to ${trip.travelAgencyName ?? 'another agency'}. Please log in to that agency to view and refresh ticketing status.`}
        className="inline-flex items-center cursor-pointer text-gray-600"
      >
        <FaInfoCircle />
      </span>
    );
  }

  return (
    <RefreshButton
      icon={<FaSync />}
      inline
      descriptionOnHover={descriptionOnHover}
      click={handleGetConfirmation}
      doShowLoadingState={isLoading}
      disabled={tripConfirmationStatus === SearchStatus.SEARCHING}
    />
  );
};

export default FlightTicketingStatus;
